module.exports = __webpack_public_path__ + "img/Invasion-BRCA_10X_WTA.d596c42b.png";